import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { OffersNacInt } from '../../../shared/models/offers.model';
import { Guid } from '../../../shared/utils/shared-utils';

@Injectable({
  providedIn: 'root',
})
export class SuperOffersService {
  constructor(private readonly httpClient: HttpClient) {}

  getOffersNationalInternational() {
    let url = `${environment.urlNmviajes}/Flight/GetMostWanted?TrackingCode=${Guid()}&MuteExceptions=${environment.muteExceptions}&Caller.Company=Agil&Caller.Application=Interagencias`;
    return this.httpClient.get<OffersNacInt>(url, {
      headers: { 'not-loading': 'true' },
    });
  }
}
